import { useQuery, UseQueryOptions } from '@tanstack/react-query'
import { Entities } from 'src/enums'
import { ProductRequestStatus } from 'src/api'
import { useApiInstance } from './useApiInstance'
import {
  buildRequestParams,
  ObjectType,
  transformPage,
  transformPerPage,
} from './helpers'

interface RequestParams {
  params?: Partial<GetParams>;
  paramsTransform?: Array<(params: Record<string, any>) => Record<string, any>>;
  options?: Omit<
    UseQueryOptions<ProductRequestStatus[], Error>,
    'queryKey' | 'queryFn'
  >;
}

interface GetParams {
  limit: number;
  offset: number;
  sort: string;
}

const schema: ObjectType['schema'] = {
  limit: 'number',
  offset: 'number',
  sort: 'string',
}

export const useProductRequestStatusListRequest = ({
  params = {},
  paramsTransform = [],
  options,
}: RequestParams = {}) => {
  const api = useApiInstance()

  const transformedParams = [
    transformPerPage,
    transformPage,
    ...paramsTransform,
  ].reduce((param, transform) => transform(param), params)

  const queryParams = buildRequestParams<GetParams>(
    transformedParams,
    schema,
  )

  return useQuery<ProductRequestStatus[], Error>(
    [Entities.ProductRequestStatus, JSON.stringify(transformedParams)],
    async () => {
      const {
        limit,
        offset,
        sort,
      } = queryParams
      const { data } = await api.v1AdminProductsRequestsStatusesGet(
        limit,
        offset,
        sort,
      )
      return data as ProductRequestStatus[]
    },
    options,
  )
}
